<template>
	<div class="news-catalog-layout">
		<GlobalHeader />
		<NewsPageHero :titleTag="isCategoryPage ? 'p' : 'h1'" />
		<div>
			<slot />
		</div>
		<LazyVisibleGlobalFooter hydrate-on-visible />
		<GlobalCallButton />
		<GlobalSmartAppBanner />
	</div>
</template>

<script setup lang="ts">
const newsStore = useNewsStore()

const isCategoryPage = computed(() => newsStore.state.pageContext?.type === 'category')
</script>
